<template>
  <carousel
    class="teasergroup_teaser__slider"
    :slides-count="itemCount"
    :options="swiperOptions"
    :preload-slide-count="1"
    :show-skip-slider-link="true"
  >
    <template
      v-for="(_, name) in $slots"
      :key="name"
      #[name]
    >
      <slot :name="name" />
    </template>
  </carousel>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import Carousel from '../../../bps/components/carousel/carousel.vue';
  import {breakpoints} from '../../../bps/variables/variables.js';
  import {calculateSlidesPerView, calculateHasTooFewItems} from '../../../bps/utilities/js/truncateSlidesInView/truncateSlidesInView'

  @Options({
    name: 'teasergroup-teaser-slider',
    components: {
      Carousel
    }
  })
  export default class TeaserGroupTeaserSlider extends Vue {
    @Prop({required: true})
    columns: number;

    @Prop({default: () => {}})
    options: any;

    itemCount = null;

    created() {
      this.itemCount = Object.keys(this.$slots).length;
    }

    get swiperOptions() {
      const defaultOptions = {
        breakpoints: {
          [0]: {
            slidesPerView: this.getSlidesPerView(-3, !this.hasTooFewItems(-3)),
            allowTouchMove: !this.hasTooFewItems(-3),
            spaceBetween: 10,
            slidesPerGroup: 1,
            centeredSlides: false,
            showPagination: true,
          },
          [breakpoints.phone]: {
            slidesPerView: this.getSlidesPerView(-2, !this.hasTooFewItems(-2)),
            allowTouchMove: !this.hasTooFewItems(-2),
            spaceBetween: 16,
            slidesPerGroup: 1,
            centeredSlides: false,
            showPagination: true,
          },
          [breakpoints.tabletSm]: {
            slidesPerView: this.getSlidesPerView(-1),
            allowTouchMove: !this.hasTooFewItems(-1),
            spaceBetween: 24,
            slidesPerGroup: Math.max(this.columns - 1, 1),
            centeredSlides: false,
            showPagination: false,
          },
          [breakpoints.tablet]: {
            slidesPerView: this.getSlidesPerView(-1),
            allowTouchMove: !this.hasTooFewItems(-1),
            spaceBetween: 24,
            slidesPerGroup: Math.max(this.columns - 1, 1),
            centeredSlides: false,
          },
          [breakpoints.laptop]: {
            slidesPerView: this.getSlidesPerView(0),
            allowTouchMove: !this.hasTooFewItems(0),
            spaceBetween: 30,
            slidesPerGroup: this.columns,
            centeredSlides: false,
          },
          [breakpoints.laptopLg]: {
            slidesPerView: this.getSlidesPerView(0),
            allowTouchMove: !this.hasTooFewItems(0),
            spaceBetween: 40,
            slidesPerGroup: this.columns,
            centeredSlides: false,
          }
        }
      };
      return {...defaultOptions, ...this.options};
    }

    getSlidesPerView(breakpointMod: number, useOffset: boolean = false): number {
      return calculateSlidesPerView(breakpointMod, this.columns, this.itemCount, useOffset);
    }

    hasTooFewItems(breakpointMod: number): boolean {
      return calculateHasTooFewItems(breakpointMod, this.columns, this.itemCount);
    }
  }
</script>
